











































import {
  defineComponent,
  PropType,
  computed,
  watch,
  nextTick,
  ref
} from '@nuxtjs/composition-api'
import { createSmoothScroll } from '@wemade-vsf/core';
import { useWmAttributes } from '@wemade-vsf/catalog/lib/runtime/product/composables/useWmAttributes';
import type { Product } from '@wemade-vsf/catalog/lib/runtime/product/types';
import { SfHeading, SfProperty, SfButton } from '@storefront-ui/vue';
import { getProductSku } from '@wemade-vsf/catalog/lib/runtime/product/getters/productGetters';

export default defineComponent({
  name: 'ProductDetailsHeader',
  props: {
    product: {
      type: [Object, null] as PropType<Product>
    }
  },
  components: {
    SfHeading,
    SfProperty,
    SfButton
  },
  setup (props) {
    const { productIdentifiers } = useWmAttributes()
    const productShortDescription = computed(
      () => {
        if (props.product?.configurable_product_options_selection?.variant?.short_description?.html) {
          return props.product.configurable_product_options_selection.variant.short_description.html
        }
        return props.product?.short_description?.html || ''
      }
    );

    const productName = computed(() => {
      if (props.product?.configurable_product_options_selection?.variant?.name) {
        return props.product.configurable_product_options_selection.variant.name
      }
      return props.product?.name || '';
    })

    const shortDesc = ref<HTMLElement | null>(null);
    const isDescriptionExpanded = ref(false)
    const isDescriptionExpandable = ref(false);
   

    const toggleDescription = () => {
      if (isDescriptionExpanded.value) {
        isDescriptionExpanded.value = false
        const top = shortDesc.value.offsetTop
        createSmoothScroll(document.documentElement.scrollTop || document.body.scrollTop, top - 20)
      } else {
        isDescriptionExpanded.value = true
      }
    }

    const testForExpandable = () => {
      isDescriptionExpanded.value = false;
      isDescriptionExpandable.value = false;
      if (process.browser && shortDesc.value) {
        console.log(shortDesc.value.scrollHeight, shortDesc.value.clientHeight)
        isDescriptionExpandable.value = shortDesc.value.scrollHeight > shortDesc.value.clientHeight
      } 
    }

    watch(() => productShortDescription.value, (newValue) => {
      nextTick(() => testForExpandable())
    })

    return {
      productName,
      getProductSku,
      productIdentifiers,
      productShortDescription,
      isDescriptionExpandable,
      isDescriptionExpanded,
      shortDesc,
      toggleDescription
    }
  }
})
